






















































import {Component, Vue} from 'vue-property-decorator'
import ScheduleOptionSelector from "@/components/OptionSelector/ScheduleOptionSelector.vue";
import ListSorter from "@/components/ListSorter/ListSorter.vue";
import MenusStore from "@/store/modules/MenusStore";
import MenuOptionSelector from "@/components/OptionSelector/MenuOptionSelector.vue";
import StoresStore from "@/store/modules/StoresStore";

@Component({
    components: {
        ListSorter,
        ScheduleOptionSelector,
        MenuOptionSelector,
    },
})

export default class MenuListSorter extends Vue {

    private headerFixPositionY!: number;

    get menuIds() {
        return MenusStore.all.map(v => v.id);
    }

    private mounted(): void {
        this.fixPanelHeader();
    }

    private destroyed(): void {
        window.removeEventListener('scroll', this.onScroll);
    }

    private menu(id: number): CMS.Menu {
        return MenusStore.menuById[id] || {};
    }

    private getStoreNames(storeIds: number[]): string {
        storeIds = (storeIds) ? storeIds.filter(store_id => StoresStore.storeById[store_id]) : storeIds;
        if (!storeIds || storeIds.length <= 0) {
            return "このメニューを使用している店舗はありません"
        }

        let result = "";
        let count = 0;
        for (let i = 0; i < storeIds.length; i++) {
            const storeId = storeIds[i];
            result += StoresStore.storeById[storeId].name + " / ";

            count++;
            if (count > 3)
                break;
        }

        if (storeIds.length <= 4) {
            result = result.slice(0, -2);
        } else {
            result += "その他" + (storeIds.length - 4) + "店舗"
        }
        return result;
    }

    private fixPanelHeader(): void {
        let header: any = document.querySelector(".panel-header");
        let rect: any = header.getBoundingClientRect();
        let scrollTop: number = window.pageYOffset || document.documentElement.scrollTop;

        this.headerFixPositionY = rect.top + scrollTop - 48 - 10;

        window.addEventListener("scroll", this.onScroll);
    }

    private onScroll(): void {
        let windowScrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        windowScrollTop > this.headerFixPositionY
            ? (<any>document).querySelector(".panel-header").classList.add('is-fixed')
            : (<any>document).querySelector(".panel-header").classList.remove('is-fixed');
    }
}

